// extracted by mini-css-extract-plugin
module.exports = {"image":"c6e8ba5398--image--3ua1b","image--layout":"c6e8ba5398--image--layout--3lgu3"};